const joinWithAnd = (items: string[]): string => {
  if (items.length <= 1) return items.join('');
  return `${items.slice(0, -1).join(', ')} and ${items.at(-1)}`;
};

export const formatMissingRequirements = (
  requirements: Array<string | false | null | undefined>
): string | null => {
  const missing = requirements.filter(
    (requirement): requirement is string =>
      typeof requirement === 'string' && requirement.trim().length > 0
  );
  if (missing.length === 0) return null;
  return `To continue, ${joinWithAnd(missing)}.`;
};
